import { RESET_STATE, SET } from "@/stores/CommumActionTypes";
import { SET_SCATTER_CHART } from "./TrendActionsType";

const mutations = {
	[SET]: (state, data) =>
	{
		state.comparativePlots.push(data);
	},
	[RESET_STATE]: (state) =>
	{
		state.comparativePlots = [];
	},
	[SET_SCATTER_CHART]: (state, data) =>
	{
		state.comparativePlots = [];
		state.comparativePlots.push(data);
	},
};

export default { mutations };
